export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GOOGLE_ID;

export const logEvent = (eventObj: {event: string; additionalInfo?: any}) => {
  const eventName = eventObj.event;
  const eventParams = {
    ...eventObj.additionalInfo,
  };
  if (typeof window !== 'undefined' && window?.dataLayer) {
    window.dataLayer?.push({
      event: eventName,
      url: window.location.href,
      ...eventParams,
    });
  }
};
